import script from "./file.vue?vue&type=script&setup=true&lang=ts"
export * from "./file.vue?vue&type=script&setup=true&lang=ts"

import "./file.vue?vue&type=style&index=0&id=384de8ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-384de8ee"]])

export default __exports__